/* eslint-disable no-unused-vars */
import { darken, lighten } from 'polished';

import { COLOR_THEME, LOGO_URL } from '../utils/themer';
import { BLACK, WHITE } from './colors';

export const baseUnit = 2.5;

export const generalTheme = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: COLOR_THEME.primary,
    borderColor: lighten(0.25, COLOR_THEME.primary),
    '&:hover': { borderColor: lighten(0.25, COLOR_THEME.primary), cursor: 'pointer' },
    boxShadow: 'none',
    width: '12rem',
    marginRight: '1em',
  }),
  menu: styles => ({
    ...styles,
    zIndex: 1000,
  }),
  valueContainer: styles => ({
    ...styles,
    padding: `${baseUnit * 2}px`,
  }),
  dropdownIndicator: styles => ({
    ...styles,
    color: COLOR_THEME.secondary,
    paddingRight: `${baseUnit * 5}px`,
  }),
  indicatorSeparator: styles => ({
    ...styles,
    display: 'none',
  }),
  placeholder: styles => ({
    ...styles,
    color: WHITE,
    padding: `${baseUnit}px ${baseUnit * 2.5}px`,
  }),
  option: (styles, state) => ({
    ...styles,
    color: BLACK,
    backgroundColor: state.isSelected ? darken(0.15, COLOR_THEME.tertiary) : WHITE,
    '&:hover': { backgroundColor: darken(0.25, COLOR_THEME.tertiary), cursor: 'pointer' },
  }),
  singleValue: styles => ({
    ...styles,
    color: WHITE,
    padding: `${baseUnit}px ${baseUnit * 2.5}px`,
  }),
};

export const settingsTheme = {
  control: (styles, state) => ({
    ...styles,
    backgroundColor: COLOR_THEME.primary,
    border: 'none',
    '&:hover': { borderColor: lighten(0.25, COLOR_THEME.primary), cursor: 'pointer' },
    boxShadow: 'none',
    overflow: 'hidden',
    width: '10rem',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  }),
  menu: styles => ({
    ...styles,
    zIndex: 1000,
  }),
  valueContainer: styles => ({
    ...styles,
    padding: `${baseUnit * 2}px`,
  }),
  dropdownIndicator: styles => ({
    ...styles,
    color: COLOR_THEME.secondary,
    paddingRight: `${baseUnit * 5}px`,
  }),
  indicatorSeparator: styles => ({
    ...styles,
    display: 'none',
  }),
  placeholder: styles => ({
    ...styles,
    color: WHITE,
    padding: `${baseUnit}px ${baseUnit * 2.5}px`,
  }),
  option: (styles, state) => ({
    ...styles,
    color: BLACK,
    backgroundColor: state.isSelected ? darken(0.15, COLOR_THEME.tertiary) : WHITE,
    '&:hover': { backgroundColor: darken(0.25, COLOR_THEME.tertiary), cursor: 'pointer' },
  }),
  singleValue: styles => ({
    ...styles,
    color: WHITE,
    padding: `${baseUnit}px ${baseUnit * 2.5}px`,
  }),
};
